import React, {useEffect} from 'react';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

const FactorDatePicker = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  const options = {year: 'numeric', month: '2-digit', day: '2-digit', calendar: 'persian'};
  const todayDate = new Date().toLocaleDateString('fa-IR', options);
  useEffect(() => {
    // اگه سری اول خالی بود ینی بک اند چیزی نفرستاده و من باید تاریخ امروز رو بزارم جای  مقدار دیت
    if (sendData.date === "") {
      setSendData({date: todayDate})
    }
  }, [sendData])
  return (

    <div className="divgroup">
      <label htmlFor="date__havaleAnbar"
             className={'top26'}
             // style={{top:'-26'}}
      >تاریخ</label>
      <DatePicker
        //id={'date_havale_anbar'}
        onChange={(date) => {
          if (date) {
            setSendData({date: date.toLocaleString()})
          } else {
            setSendData({date: ""})
          }
        }}

        calendar={persian}
        className="form-control"
        placeholder="تاریخ"
        locale={persian_fa}
        // value={sendData.date==="" ? "1" : sendData.date}
        value={sendData.date || todayDate}
        calendarPosition="bottom-right"
        hideOnScroll

      />
    </div>
   );
};

export default FactorDatePicker;
